module.exports = __webpack_public_path__ + "img/10.26e4aef2.jpg";